import { useEffect } from 'react'
import { debounce } from '@utils/helpers'
import { isEmbedded, postMessageToParent } from '@utils/iframe'
import { useEmbedConfig } from './useEmbedConfig'

export function useIframeHeight() {
  const { heightMode } = useEmbedConfig()

  useEffect(() => {
    // `fill` hosts size the frame themselves.
    if (!isEmbedded() || heightMode === 'fill') {
      return
    }

    const root = document.getElementById('root')
    if (!root) {
      return
    }

    let lastHeight = 0

    // Measure and observe #root, not documentElement/body: those are stretched to the
    // frame the parent gave us, so they can only ever report growth.
    const sendHeight = debounce(() => {
      const height = Math.ceil(root.getBoundingClientRect().height)

      // Sub-pixel jitter only; anything larger, up OR down, is a real change.
      if (Math.abs(height - lastHeight) <= 1) {
        return
      }

      lastHeight = height
      postMessageToParent({ type: 'iframeHeight', height })
    }, 100)

    const observer = new ResizeObserver(() => sendHeight())
    observer.observe(root)
    sendHeight()

    return () => {
      observer.disconnect()
      sendHeight.cancel()
    }
  }, [heightMode])
}
